import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@24.12.4_@vue+compiler-sfc@3.5.35_cac@6.7._07bfedff0c1c82e81e14dd9d7a28cad8/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}